import { render, staticRenderFns } from "./settings-authentication.vue?vue&type=template&id=1194141b"
import script from "./settings-authentication.vue?vue&type=script&lang=js"
export * from "./settings-authentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports